import { LOCAL_STORAGE_KEY_JWT } from '@/api'
import { MissionsUrlProvider } from '@/features/missions/context/MissionsUrlProvider'
import {
  NectarMissionDetailForAuthorizedUser,
  NectarMissionDetailForUnauthorizedUser
} from '@/features/missions/MissionsWrappers'
import { Page } from '@/ui-kit'
import { useLocalStorage } from '@/utils/useLocalStorage'
import { useParams } from 'react-router-dom'

const NectarTaskPage = () => {
  const [jwt] = useLocalStorage(LOCAL_STORAGE_KEY_JWT, '')
  const { projectId } = useParams<{ projectId: string }>()

  return (
    <MissionsUrlProvider isWebview={false}>
      <Page>
        {jwt ? (
          <NectarMissionDetailForAuthorizedUser missionId={projectId ?? ''} />
        ) : (
          <NectarMissionDetailForUnauthorizedUser missionId={projectId ?? ''} />
        )}
      </Page>
    </MissionsUrlProvider>
  )
}

export default NectarTaskPage
